import React from "react";

export default function NoMovieFound() {
  return (
    <div className="noMovie">
      <p className={"text-center align-middle"}>
        WE COULD NOT FIND A FILM THAT MATCHES <br /> THE SEARCH CRITERIA
      </p>
    </div>
  );
}
